import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TSharedDTO } from '~/types/DTO/shared';
import { IAdditionalSignerState } from '~/interfaces/AdditionalSigner';
import { ApiStatus } from '../types/sharedTypes';
import { SignerType } from '~/enums';

const additionalSignerInitialState = Object.freeze<IAdditionalSignerState>({
  otpExpiryTimestamp: null,
  otp: '',
  otpError: null,
  timerCompleted: false,
  additionalSignerLoanApplicationOffer: {
    amount: '',
    bank_account: '',
    company_name: '',
    company_no: '',
    first_name: '',
    landing_url: '',
    language: '',
    last_name: '',
    monthly_fee: '',
    monthly_payment: '',
    payment_due: '',
    personal_id: '',
    signer_type: SignerType.Signer,
    term: 0,
    granter: '',
  },
  additionalSignerCardApplicationOffer: {
    cardApplicationUuid: '',
    companyName: '',
    hasAcceptedPersonalGuarantee: false,
    hasAcceptedTerms: false,
    interest: 0,
    offeredCreditLimit: 0,
    signerUuid: '',
  },
  apiStatus: {
    initiateOTP: ApiStatus.Idle,
    regenerateOTP: ApiStatus.Idle,
    verifyOTP: ApiStatus.Idle,
    fetchAdditionalSignerLoanApplication: ApiStatus.Idle,
    fetchAdditionalSignerCardApplication: ApiStatus.Idle,
    postAdditionalSignerCardApplication: ApiStatus.Idle,
    postAdditionalSignerLoanApplication: ApiStatus.Idle,
  },
});

const additionalSignerSlice = createSlice({
  name: 'additionalSigner',
  initialState: additionalSignerInitialState,
  reducers: {
    setOTPExpiryTimestamp: (state, action: PayloadAction<number>) => {
      state.otpExpiryTimestamp = action.payload;
    },
    setOTP: (state, action: PayloadAction<string>) => {
      state.otp = action.payload;
    },
    setOTPError: (
      state,
      action: PayloadAction<IAdditionalSignerState['otpError']>
    ) => {
      state.otpError = action.payload;
    },
    setTimerCompleted: (state, action: PayloadAction<boolean>) => {
      state.timerCompleted = action.payload;
    },
    setAdditionalSignerLoanApplicationData: (
      state,
      action: PayloadAction<
        TSharedDTO['getAdditionalSignerLoanApplicationDataRes']
      >
    ) => {
      state.additionalSignerLoanApplicationOffer = action.payload;
    },
    setAdditionalSignerCardApplicationData: (
      state,
      action: PayloadAction<
        TSharedDTO['getAdditionalSignerCardApplicationDataRes']
      >
    ) => {
      state.additionalSignerCardApplicationOffer = action.payload;
    },
    setApiStatus: (
      state,
      action: PayloadAction<Partial<IAdditionalSignerState['apiStatus']>>
    ) => {
      state.apiStatus = {
        ...state.apiStatus,
        ...action.payload,
      };
    },
  },
});

export const {
  setOTPExpiryTimestamp,
  setOTP,
  setOTPError,
  setTimerCompleted,
  setAdditionalSignerLoanApplicationData,
  setAdditionalSignerCardApplicationData,
  setApiStatus,
} = additionalSignerSlice.actions;

export default additionalSignerSlice.reducer;
